export const toPersianNumber = (value) => {
  if (value === null || value === undefined) return "";

  return value
    .toString()
    .replace(/\d/g, (d) => "۰۱۲۳۴۵۶۷۸۹"[d]);
};

export const persianAmount = (value) => {
  const numericValue = Number(value || 0);

  return toPersianNumber(
    Math.round(numericValue)
      .toLocaleString("en-US")
      .replace(/,/g, "٬")
  );
};

export const toman = (value) => {
  return `${persianAmount(value)} تومان`;
};

export const tomanParts = (value) => {
  return {
    amount: persianAmount(value),
    currency: "تومان"
  };
};
